// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__15VUS","inner":"Footer_inner__1NG-t","nextIcon":"Footer_nextIcon__2nHKl","innerLeft":"Footer_innerLeft__3GLBT"};